import { ActionOrderInput } from 'models/order-input/action-order';
import { createContext, Dispatch, SetStateAction } from 'react';

type ActionOrderContextType = {
    order: ActionOrderInput;
    setOrder: Dispatch<SetStateAction<ActionOrderInput>>;
};
export const ActionOrderContext = createContext<ActionOrderContextType>({
    order: {} as ActionOrderInput,
    setOrder: () => {
        return;
    },
});
